import React, { useEffect, useState } from "react";
import { FaRupeeSign, FaStar } from "react-icons/fa";
import { description } from "../assets/data/enroll";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import Assistance from "../components/Assistance";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const SelectPlan = () => {
  const { token } = useSelector((state) => state.token);
  const { url, user } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [planLoading, setPlanLoading] = useState(false);
  const [recommended, setRecommended] = useState(null);
  const [plans, setPlans] = useState([
    {
      months: 12,
      emi: 0,
      subscription: 0,
      total: 0,
    },
    {
      months: 18,
      emi: 0,
      subscription: 0,
      total: 0,
    },
    {
      months: 24,
      emi: 0,
      subscription: 0,
      total: 0,
    },
    {
      months: 36,
      emi: 0,
      subscription: 0,
      total: 0,
    },
    {
      months: 48,
      emi: 0,
      subscription: 0,
      total: 0,
    },
    {
      months: 60,
      emi: 0,
      subscription: 0,
      total: 0,
    },
  ]);
  const restructure = async () => {
    setLoading(true);
    const calculateDI = parseFloat(user.Income) - parseFloat(user.Expenses);
    //
    const updatedPlans = plans.map((item, index) => {
      const emi = parseFloat(user.Outstanding) / parseFloat(item.months);

      const subscription = (parseFloat(emi) * 30) / 100;
      const total = parseFloat(emi) + parseFloat(subscription);

      return {
        ...item,
        index,
        emi: parseFloat(emi.toFixed(0)),
        subscription: parseFloat(subscription.toFixed(0)),
        total: parseFloat(total.toFixed(0)),
      };
    });
    setPlans(updatedPlans);
    //
    const eligiblePlans = updatedPlans.filter(
      (item) => item.total < calculateDI && item.total > 9999
    );
    if (eligiblePlans.length > 0) {
      const closestPlan = eligiblePlans.reduce((prev, curr) =>
        Math.abs(curr.total - calculateDI) < Math.abs(prev.total - calculateDI)
          ? curr
          : prev
      );
      setRecommended(closestPlan.index);
    } else {
      setRecommended(null);
    }
    //
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };
  useEffect(() => {
    restructure();
  }, [user]);

  //
  const [tempLoad, setTempLoad] = useState(null);
  const selectPlan = async (selectedPlan, index) => {
    try {
      setTempLoad(index);
      setPlanLoading(true);
      const data = [
        {
          Plan_Type: `${selectedPlan.months} months`,
          Monthly_EMI_Payment: selectedPlan.emi.toString(),
          Total_Plan_Amount: selectedPlan.total.toString(),
          Subscription_Fees: selectedPlan.subscription.toString(),
          Step: 2,
        },
      ];
      //
      const res = await axios.put(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/Leads/${user.id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${token}`,
          },
        }
      );
      if (res.status === 200) {
        navigate("/payment", { replace: true });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setPlanLoading(false);
    }
  };
  return (
    <>
      <div className="container p-2">
        <Assistance
          body={
            "After reviewing all the information, your tailored solutions are below"
          }
        />
        <div className="assistance-seperator"></div>
        <div className="description pb-4">
          <h1 className="text-center primary-text">
            Harassment and debt solutions
          </h1>
          <div className="description-grid mt-4">
            {description.slice(0, 2).map((item, index) => {
              return (
                <div
                  className={`description-card description-card-${index + 1}`}
                  key={index}
                >
                  <div className="description-img">
                    <img src={item.img} alt="" />
                  </div>
                  <div>
                    <h2 className="primary-text">{item.title}</h2>
                    <p>{item.body}</p>
                    {index === 2 ? (
                      <button className="button description-button">
                        Read more
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div>
          <h1 className="primary-text text-center mb-4">
            Select your affordable tentative plan below
          </h1>
          {loading ? (
            <div className="text-center my-4">
              <div
                className="spinner-border spinner-border-xxl pink-loader"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              <Swiper
                spaceBetween={8}
                slidesPerView={1}
                pagination={{ clickable: true }}
                navigation
                modules={[Navigation]}
                initialSlide={0}
                loop
                breakpoints={{
                  200: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                  992: {
                    slidesPerView: 3,
                  },
                }}
              >
                {plans.map((item, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <div
                        className={`plan-card ${
                          item.emi < 9999
                            ? "justify-content-center"
                            : "justify-content-between"
                        }`}
                      >
                        {item.emi > 9999 && recommended === index ? (
                          <div className="recommended">
                            <FaStar />
                          </div>
                        ) : (
                          ""
                        )}

                        {item.emi < 9999 ? (
                          <p>
                            You are not eligible for this plan because your EMI
                            is coming out to be less than 10,000.
                          </p>
                        ) : (
                          <>
                            <div>
                              <h1>{item.months} months plan</h1>
                            </div>
                            <div>
                              <div className="plan-flex">
                                <p>Monthly EMI</p>
                                <h2 className="fw-bold">
                                  <FaRupeeSign />
                                  {item.emi.toLocaleString("en-IN")}
                                </h2>
                              </div>
                              <div className="plan-flex">
                                <p>Subscription Fee</p>
                                <h2 className="fw-bold">
                                  <FaRupeeSign />
                                  {item.subscription.toLocaleString("en-IN")}
                                </h2>
                              </div>
                              <div className="plan-flex">
                                <p>One Time Fee</p>
                                <h2 className="fw-bold">
                                  <FaRupeeSign />
                                  599
                                </h2>
                              </div>
                              <hr />
                              <div className="plan-flex">
                                <p>Final Amount</p>
                                <h2 className="fw-bold">
                                  <FaRupeeSign />
                                  {item.total.toLocaleString("en-IN")}
                                </h2>
                              </div>
                            </div>
                          </>
                        )}
                        {item.emi < 9999 ? (
                          ""
                        ) : (
                          <button
                            className={`button plan-button ${
                              item.emi < 9999 ? "disabled-button" : ""
                            }`}
                            onClick={() => selectPlan(item, index)}
                            style={{ minWidth: "65px" }}
                            id={`plan${index + 1}`}
                          >
                            {tempLoad === index && planLoading ? (
                              <div className="text-center">
                                <div
                                  className="spinner-border spinner-border-sm pink-loader"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </div>
                            ) : (
                              "Select"
                            )}
                          </button>
                        )}
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </>
          )}
        </div>

        <div className="golden-box">
          <h1 className="text-center">
            Our one time fee <FaRupeeSign />
            599{" "}
          </h1>
          <div>
            {description[2].body.map((item, index) => {
              return (
                <div
                  className={`${
                    index === description[2].body.length - 1 ? "" : "mb-2"
                  } goldren-flex`}
                  key={index}
                >
                  <img src={item.img} alt="" />
                  <p className="fw-bold">{item.content}</p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="text-center mt-4">
          <button
            className="button"
            id="back-to-form2"
            onClick={() => navigate("/enroll")}
          >
            Back
          </button>
        </div>
      </div>
    </>
  );
};

export default SelectPlan;
